var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9129 11C17.3401 11 17.5705 11.5011 17.2925 11.8254L12.3796 17.5571C12.1801 17.7899 11.8199 17.7899 11.6204 17.5571L6.70748 11.8254C6.42948 11.5011 6.65993 11 7.08711 11L9.5 11C9.77614 11 10 10.7761 10 10.5L10 2.5C10 2.22386 10.2239 2 10.5 2L13.5 2C13.7761 2 14 2.22386 14 2.5L14 10.5C14 10.7761 14.2239 11 14.5 11L16.9129 11Z",
    fill: "#0D5582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 23.5C24 23.7761 23.7761 24 23.5 24H0.5C0.223858 24 0 23.7761 0 23.5V22.5C0 22.2239 0.223857 22 0.5 22H23.5C23.7761 22 24 22.2239 24 22.5V23.5Z",
    fill: "#0D5582"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 16C23.7761 16 24 16.2239 24 16.5L24 23.5C24 23.7761 23.7761 24 23.5 24L22.5 24C22.2239 24 22 23.7761 22 23.5L22 16.5C22 16.2239 22.2239 16 22.5 16L23.5 16Z",
    fill: "#0D5582"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 16C1.77614 16 2 16.2239 2 16.5L2 23.5C2 23.7761 1.77614 24 1.5 24L0.5 24C0.223858 24 -9.39372e-09 23.7761 -2.09815e-08 23.5L-3.14722e-07 16.5C-3.2631e-07 16.2239 0.223857 16 0.5 16L1.5 16Z",
    fill: "#0D5582"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHover);
export default __webpack_public_path__ + "static/media/downloadHover.e82778226671d8ce939d474217cdec0f.svg";
export { ForwardRef as ReactComponent };